/** Admin helpers: URL-driven filters and paging, so every list is linkable and survives a refresh. */
import { register } from '../../core/events.js';
import { html } from '../../core/html.js';
import { navigate } from '../../core/router.js';
import { ic } from '../../ui/components.js';

export const PAGE = 25;

/** Current query as a plain object. */
export const queryOf = (ctx) => Object.fromEntries(ctx.query.entries());

export function withQuery(path, params) {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== '' && v != null) q.set(k, v);
  const s = q.toString();
  return s ? `${path}?${s}` : path;
}

register({
  /** <select data-change="admin.filter" data-param="role"> or <input data-enter="admin.filter" data-param="q"> */
  'admin.filter': (el) => {
    const url = new URL(location.href);
    if (el.value) url.searchParams.set(el.dataset.param, el.value.trim());
    else url.searchParams.delete(el.dataset.param);
    url.searchParams.delete('offset');
    return navigate(url.pathname + url.search);
  },
});

export function filterSelect(label, param, options, current, allLabel = 'All') {
  return html`<label class="row sm" style="gap:6px"><span class="mu">${label}</span>
    <select data-change="admin.filter" data-param="${param}" aria-label="${label}"><option value="">${allLabel}</option>${options.map(([v, t]) => html`<option value="${v}" ${v === current ? html`selected` : ''}>${t}</option>`)}</select></label>`;
}

export function searchBox(param, current, placeholder) {
  return html`<input style="width:260px" type="search" placeholder="${placeholder}" aria-label="${placeholder}" value="${current || ''}" data-param="${param}" data-enter="admin.filter">`;
}

/** Previous / next links for an endpoint that takes limit and offset. */
export function pager(path, query, shown) {
  const offset = Number(query.offset) || 0;
  const prev = offset > 0 ? withQuery(path, { ...query, offset: Math.max(0, offset - PAGE) || '' }) : '';
  const next = shown >= PAGE ? withQuery(path, { ...query, offset: offset + PAGE }) : '';
  if (!prev && !next) return '';
  return html`<div class="row between mt-s"><span class="sm mu">Showing ${offset + 1} to ${offset + shown}</span>
    <div class="row">${prev ? html`<a class="btn ghost sm" href="${prev}">${ic('left')} Previous</a>` : ''}${next ? html`<a class="btn ghost sm" href="${next}">Next ${ic('chev')}</a>` : ''}</div></div>`;
}
